import { Page } from './Page'

export { Page }
